module.exports = {
      id: "adventure-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#adventure",
      toString: function () {
        return this.url;
      }
    }